import React from 'react';

import classNames from 'classnames';

import s from 'components/loadingOverlay/loadingOverlay.scss';

/**
 * Loading overlay with opacity
 */
export const LoadingOverlay = ({className, ...props}: JSX.IntrinsicElements['div']) => {
    return <div {...props} className={classNames(s.loadingOverlay, className)} />;
};
